export default "__VITE_ASSET__C7isph2d__"